import { render, staticRenderFns } from "./VoteSlide.vue?vue&type=template&id=de41739a&scoped=true"
import script from "./VoteSlide.vue?vue&type=script&lang=js"
export * from "./VoteSlide.vue?vue&type=script&lang=js"
import style0 from "./VoteSlide.vue?vue&type=style&index=0&id=de41739a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de41739a",
  null
  
)

export default component.exports